export default __webpack_public_path__ + "static/media/airlockz-bpk-banner-3.a981afc5.jpg";